import { Button, makeStyles, Container, Card, CardContent, CardActions, InputAdornment } from '@material-ui/core'
import CardTitle from 'components/card/title'
import { useSession } from 'components/session/session'
import { DropzoneArea } from 'material-ui-dropzone'
import { Checkboxes, makeValidate, TextField } from 'mui-rff'
import { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import { OnChange } from 'react-final-form-listeners'
import slugify from 'slugify'
import * as yup from 'yup'
import { firebase } from '@firebase/app'
import '@firebase/firestore'
import '@firebase/storage'

// eslint-disable-next-line no-undef
const rsd = require('reserved-subdomains')

const useStyles = makeStyles((theme) => ({
  buttonBlue: {
    color: theme.palette.getContrastText(theme.palette.info.main),
    backgroundColor: theme.palette.info.main,
    marginRight: '10px',
    '&:hover': {
      backgroundColor: theme.palette.info.dark,
    }
  },
  dropzoneClass: {
    minHeight: '0px',
    width: '100%',
  },
  hiddenDropzone: {
    display: 'none'
  },
  topSpacer: {
    height: '0px',
    [theme.breakpoints.up('md')]: {
      height: '50px',
    },
  },
}))

export default function Simplemnt() {
  const session = useSession()
  const classes = useStyles()
  const [logo, setLogo] = useState(null)
  const [usedDomains, setUsedDomains] = useState([])

  // Get Used Domains
  useEffect(() => {
    fetch('/api/getUsedSubdomains')
      .then(e => e.json())
      .then(e => {
        setUsedDomains(e.domains)
        console.log(e.domains)
      })
  }, [])

  yup.addMethod(yup.string, 'domain', function (message) {
    return this
      .test({
        name: 'domain',
        exclusive: true,
        message: message || 'This domain is not available',  // expect an i18n message to be passed in
        test: async value => rsd.isValid(value) && usedDomains.indexOf(value) < 0
      })
  })

  let schema = yup.object().shape({
    Name: yup.string().required(),
    Domain: yup.string().domain()
  })
  const validate = makeValidate(schema)

  if (!session?.org?.data || !session?.user?.email) return <></>
  return <Form
    initialValues={{}}
    validate={validate}
    onSubmit={async values => {
      // eslint-disable-next-line no-useless-escape
      values.Domain = slugify(values.Domain.toLowerCase()).replace(/[^a-zA-Z0-9\-]/g, '')
      if (rsd.isNotValid(values.Domain) || usedDomains.indexOf(values.Domain) > -1) {
        session.snackbar.setSnackbar({
          severity: 'error',
          message: 'This domain is not available'
        })
        return
      }
      console.log(JSON.stringify({ email: session.user.email, ...values }))
      const resp = await fetch('/api/createNewOrg', { method: 'POST', body: JSON.stringify({ ...values, email: session.user.email }) })
      console.log(resp.status)
      if (resp.status != 200) {
        session.snackbar.setSnackbar({
          severity: 'error',
          message: 'This domain is not available'
        })
        return
      }
      if (values.Training) window.open('https://calendly.com/sai-simplemnt/30min', '_blank')
      const respJson = await resp.json()
      const id = respJson.id
      console.log(id)
      if (logo) {
        try {
          const logoRef = firebase.storage().ref(`/logos/${id}-logo.${logo.name.split('.').pop()}`)
          const uploadTask = logoRef.put(logo)
          await uploadTask
          firebase.firestore().collection('Orgs').doc(id).set({ Logo: await logoRef.getDownloadURL() }, { merge: true })
        } catch (e) {
          console.error(e)
          session.snackbar.setSnackbar({
            severity: 'error',
            message: 'Error Uploading File'
          })
        }
      }
      console.log(respJson)
      window.location.replace(respJson.url)
    }}
    render={({ handleSubmit, values }) => <form onSubmit={handleSubmit}>
      <Container maxWidth='sm' style={{ marginTop: '30px' }}><Card>
        <CardContent style={{ marginTop: '10px' }}>
          <CardTitle title='Your Company Details' subtitle='To provision your Simplemnt instance, we need some basic information from you.' />
          <TextField name='Name' label='Your Company Name' variant='outlined' style={{ marginBottom: '10px' }} />
          <OnChange name='Name'>{value => {
            values.Domain = slugify(value.toLowerCase())
          }}</OnChange>
          <DropzoneArea
            onChange={files => setLogo(files[0])}
            dropzoneClass={logo ? classes.hiddenDropzone : classes.dropzoneClass}
            previewText=''
            showPreviewsInDropzone={false}
            showPreviews={true}
            dropzoneText={<span>Your Company Logo <span style={{ fontSize: '0.5em', display: 'block' }}>Please make sure the logo is under 5 MB</span></span>}
            acceptedFiles={['image/jpeg', 'image/png', 'image/webp', 'image/svg']}
            filesLimit={1}
            maxFileSize={5e+6} // 5 MB Max file size
          />
          <TextField name='Domain' label='Domain' variant='outlined' style={{ marginTop: '10px', marginBottom: '10px' }} InputProps={{ endAdornment: <InputAdornment position="end">.simplemnt.com</InputAdornment> }} />
          <Checkboxes name='Training' label='Would you like to schedule a free 30 minute training?' data={[{ label: 'Yes', value: true }]} />
        </CardContent>
        <CardActions>
          <Button varient='contained' className={classes.buttonBlue} type='submit'>Get Started</Button>
        </CardActions>
      </Card></Container>
    </form>}
  />

}